import { Injectable } from '@angular/core';
import { NavItem, PartnerNavItem } from '@nimmsta/ng-commons-lib/menu';
import { NavItemService } from '@nimmsta/ng-commons-lib/navigation';
import { UserRole } from '@nimmsta/ng-commons-lib/models';
import { Observable, of } from 'rxjs';

@Injectable()
export class WorkflowNavItemService implements NavItemService {
  getSidebarNavItems(): Observable<NavItem[]> {
    return of([
      new NavItem('dashboard', 'dashboard.nav', 'dashboard', [
        UserRole.ADMIN,
        UserRole.MANAGER,
      ]),
      new NavItem('workflows', 'workflow.nav', 'rebase', {
        anyPermissions: ['workflow.read'],
      }),
      new NavItem(
        'dataconnection',
        'dataconnection.nav',
        'settings_input_component',
        { anyPermissions: ['data_connection.read'] },
      ),
      new NavItem('workflow-data-stores', 'workflow_data_store.nav', 'hub', {
        anyPermissions: ['data_connection.read'],
      }),
      new NavItem(
        'jobs',
        'job.nav',
        'work',
        { anyPermissions: ['job.read'] },
        undefined,
        undefined,
        [
          'open-jobs',
          'done-jobs',
          'cancelled-jobs',
          'deleted-jobs',
          'all-jobs',
        ],
      ),
      new NavItem('users', 'user.nav', 'person', {
        anyRoles: [UserRole.ADMIN, UserRole.MANAGER],
        anyPermissions: ['worker.read', 'worker.write'],
      }),
      new PartnerNavItem(
        'partner-organizations',
        'organizations.nav',
        'groups',
        [UserRole.ADMIN, UserRole.MANAGER],
      ),
      new NavItem('software', 'software.nav', 'download', [
        UserRole.ADMIN,
        UserRole.MANAGER,
      ]),
      new NavItem('devices', 'device.nav', 'devices', [
        UserRole.ADMIN,
        UserRole.MANAGER,
      ]),
      new NavItem('information', 'information.nav', 'info', [
        UserRole.ADMIN,
        UserRole.MANAGER,
      ]),
      new NavItem('support', 'support.nav', 'support'),
    ]);
  }

  getHeaderBarNavItems(): Observable<NavItem[]> {
    return of([
      new NavItem('workflow-emails', 'workflow-email.nav', 'email', {
        anyPermissions: ['workflow.read', 'workflow.write'],
      }),
      new NavItem('dashboard-edit', 'dashboard.edit.nav', 'dashboard', [
        UserRole.ADMIN,
        UserRole.MANAGER,
      ]),
      new NavItem(
        '',
        'admin.nav',
        'manage_accounts',
        [UserRole.ADMIN],
        undefined,
        [
          // sub items
          new NavItem('workflow-templates', 'workflow.default.nav', 'star', [
            UserRole.ADMIN,
          ]),
          new NavItem(
            'dataconnection-templates',
            'dataconnection.template.nav',
            'settings_input_component',
            [UserRole.ADMIN],
          ),
          new NavItem('users-all', 'user.nav-all', 'person', [UserRole.ADMIN]),
          new NavItem('organizations', 'organizations.nav', 'groups', [
            UserRole.ADMIN,
          ]),
          new NavItem('admin-jobs', 'job.admin.nav', 'work_history', [
            UserRole.ADMIN,
          ]),
        ],
        [],
        true, // expanded
      ),
    ]);
  }
}
